import { Button } from 'antd';
import { SonarCard } from '@ui/general';
import { useNavigate } from 'react-router-dom';
import { VisibleIssuesList } from '../issues';

import { COPY_SPECIFIC, FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import React, { useCallback } from 'react';

export const Issues: React.FC = () => {
	const navigate = useNavigate();

	const handleOnViewAllIssuesClick = useCallback(() => {
		navigate(FULL_ROUTES.ISSUES);
	}, [ navigate ]);

	return (
		<SonarCard
			extra={
				<Button
					id='view-all-issues-button'
					onClick={ handleOnViewAllIssuesClick }>
					{ COPY_SPECIFIC.VIEW_ALL_ISSUES }
				</Button>
			}
			noSpacing
			title={ COPY_SPECIFIC.VALIDATION_RULE_ISSUES }
			titleClassName='h2'>
			<VisibleIssuesList
				hideActions
				limit={ 5 } />
		</SonarCard>
	);
};
